








import { Component, Vue } from "vue-property-decorator";
// import dev from "@/components/dev.vue";
import routes from "./routes";
import HomeLayout from "@/layout/homeLayout.vue";

@Component({
  components: {
    // dev,
    HomeLayout,
  },
})
export default class App extends Vue {
  get route() {
    return routes.find((item: any) => item.name === this.$route.name);
  }
  get layout() {
    return (this.route && this.route.layout) || "div";
  }
  get layoutOptions() {
    return (this.route && this.route.layoutOptions) || {};
  }
}
